import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { CsAttributeDebug } from "@plansoft-configuration-renderer/debug";
import { AttributeComponentContext } from "../ComponentContext/AttributeComponentContext";
import { LayoutError } from "../ReactPageLayout/LayoutError";
import { LayoutGridType } from "../ReactPageLayout/LayoutGridType";
import { LayoutRows } from "../ReactPageLayout/LayoutRows";
import { PluginHelper } from "../ReactPageLayout/helpers/PluginHelper";
import { AttributeCellInner } from "./AttributeCellInner";
import { AttributeLayoutProvider, } from "./AttributeLayoutContext";
export function AttributeCell({ node }) {
    var _a, _b;
    const attributeProps = PluginHelper.getPluginProps(node);
    // lookup component for rendering values
    const components = useContext(AttributeComponentContext);
    const pluginId = PluginHelper.getPluginId(node);
    const Component = (_a = components[pluginId]) !== null && _a !== void 0 ? _a : AttributeComponentFallback;
    if (!attributeProps.identifier) {
        return (_jsxs(LayoutError, { layoutNode: node, children: ["No identifier specified for attribute node ", node.id] }));
    }
    if (!((_b = node.rows) === null || _b === void 0 ? void 0 : _b.length)) {
        return (_jsxs(LayoutError, { layoutNode: node, children: ["No control nodes found for attribute node ", node.id] }));
    }
    // the layout gets props from control node and attribute
    const attributeLayoutProps = Object.assign({}, attributeProps);
    const numberFormatOptions = attributeProps.overrideNumberFormatOptions
        ? attributeLayoutProps.numberFormatOptions
        : undefined;
    return (_jsx(AttributeLayoutProvider, Object.assign({}, attributeLayoutProps, { children: _jsx(AttributeCellInner, { attributeId: attributeLayoutProps.identifier, numberFormatOptions: numberFormatOptions, children: _jsxs(Component, Object.assign({}, attributeLayoutProps, { children: [_jsx(CsAttributeDebug, {}), _jsx(LayoutRows, { rows: node.rows, gridType: LayoutGridType.Attribute })] })) }) })));
}
function AttributeComponentFallback(props) {
    return _jsx(Fragment, { children: props.children });
}
//# sourceMappingURL=AttributeCell.js.map